export default "__VITE_ASSET__2TQJuN02__"